/**
 * VendorPortalLocationService
 * Service for vendor operational location management.
 * Allows vendors to manage which locations they operate in.
 * Route: api/vendor-portal/locations
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalLocationService
 * Handles vendor operational location operations for the vendor portal.
 * Maps to /api/vendor-portal/locations endpoint
 */
export class VendorPortalLocationService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalLocationService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalLocationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET MY LOCATIONS ====================
    /**
     * Get all operational locations for the current vendor
     * GET /api/vendor-portal/locations
     */
    async getMyLocations() {
        const response = await this.getMyLocationsRaw();
        return response.data ?? [];
    }
    /**
     * Get all operational locations (raw response)
     */
    getMyLocationsRaw() {
        return this.get();
    }
    // ==================== ADD LOCATION ====================
    /**
     * Add an operational location to the current vendor
     * POST /api/vendor-portal/locations/{locationId}
     * @param locationId The location ID to add
     */
    async addLocation(locationId) {
        const response = await this.addLocationRaw(locationId);
        if (!response.data) {
            throw new Error('Failed to add location');
        }
        return response.data;
    }
    /**
     * Add an operational location (raw response)
     */
    addLocationRaw(locationId) {
        return this.post(String(locationId), {});
    }
    // ==================== REMOVE LOCATION ====================
    /**
     * Remove an operational location from the current vendor
     * DELETE /api/vendor-portal/locations/{locationId}
     * @param locationId The location ID to remove
     */
    async removeLocation(locationId) {
        const response = await this.removeLocationRaw(locationId);
        return response.success;
    }
    /**
     * Remove an operational location (raw response)
     */
    removeLocationRaw(locationId) {
        return this.delete(String(locationId));
    }
}
VendorPortalLocationService.DEFAULT_SERVICE_PATH = 'vendors';
VendorPortalLocationService.BASE_PATH = 'api/vendor-portal/locations';
//# sourceMappingURL=VendorPortalLocationService.js.map